export class ProvisionReadiness {
  status: string
}

export enum ProvisionReadinessStatus {
  ReadyForProvisioning = 'ReadyForProvisioning',
  CannotProvision = 'CannotProvision',
  Pending = 'Pending',
}
